<template>
  <div class="site__centered application-steps">

    <b-tabs
      v-model="tabIndex"
      vertical
      pills
      content-class="application-steps__tab-content"
      :nav-wrapper-class="isCollapsed ? 'application-steps__tabs is-tabs-collapsed' : 'application-steps__tabs'"
      nav-class="nav-left"
      active-nav-item-class="application-steps__tab_active"
    >
      <template #tabs-start>
        <li
          class="application-steps__header"
          @click="toggleCollapseTabs"
        >
          Steps Application Form
          <span 
            class="collapse-icon"
            :class="{'open': isCollapsed}"
          ></span>
        </li>
      </template>
      <b-tab
        v-for="(step, index) in filteredStepsList"
        :key="index"
        title-item-class="application-steps__tab"
        title-link-class="application-steps__tab-link"
        :disabled="step.isDisabled"
        @click="setTabIndexQuery"
      >
        <template #title>
          <div>
            <span class="font-weight-bold text-primary">{{ stepIndex(index) }} <b>{{ step.name }}</b></span>
          </div>
          <div
            v-if="step.status && step.status !== 'Approved'"
            class="application-steps__tab-status"
          >{{ step.status }}</div>
          <div
            v-if="step.status && step.status === 'Approved'"
            class="application-steps__tab-status_approved"
          ></div>
        </template>

        <ApplicationStepForm
          v-if="step.preparedFields && isDataFullPrepared"
          :step="step"
          :form-fields="step.preparedFields"
          @nextStep="goNextTabIfAvailable"
        />
      </b-tab>

    </b-tabs>

    <group-users-list-modal />
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'

import ApplicationStepForm from '@/views/Application/ApplicationStepForm.vue'
import store from '@/store'
import { mapGetters } from 'vuex'

import GroupUsersListModal from '@/components/site/group-users-list/GroupUsersListModal.vue'
import axios from '@axios'

export default {
  components: {
    BTabs,
    BTab,

    ApplicationStepForm,
    GroupUsersListModal,
  },
  filters: {
    toFixedNuber(value) {
      return value.toFixed(2)
    }
  },
  data() {
    return {
      userId: this.$router.currentRoute.query.user_id || getUserData().id,
      type: ['parent', 'child'].includes(getUserData().role) ? 'Camper' : 'Staff',
      isCollapsed: false,
    }
  },
  computed: {
    ...mapGetters({
      applicationId: 'applicationRegistration/getApplicationId',
      programName: 'applicationRegistration/getProgramName',
      isApplicationAccepted: 'applicationRegistration/getIsApplicationAccepted',
      filteredStepsList: 'applicationRegistration/getFilteredStepsList',
      paymentContractIsExist: 'applicationRegistration/getPaymentContractIsExist',
    }),
    tabIndex: {
      get: function () {
        return store.getters['applicationRegistration/getCurrentTabIndex']
      },
      set: function (val) {
        store.commit('applicationRegistration/SET_TAB_INDEX', val)
      }
    },
    isDataFullPrepared: {
      get: function () {
        return store.getters['applicationRegistration/getIsDataFullPrepared']
      },
      set: function (val) {
        store.commit('applicationRegistration/SET_IS_DATA_FULL_PRAPARED', val)
      }
    }
  },
  watch: {
    tabIndex(val) {
      if (this.applicationId) {
        this.setApplicationData(this.applicationId)
      }

      if (val > 0) {
        this.setTabIndexQuery()
      }
    },
  },
  async created() {
    store.commit('applicationRegistration/RESET_STATE')
    store.commit('applicationRegistration/SET_TYPE', this.type)
    store.commit('applicationRegistration/SET_USER_ID', this.userId)

    store.commit('SET_LOADING_STATUS', true)

    const applicationId = this.$router.currentRoute.query.app_id
    if (applicationId) {
      store.commit('applicationRegistration/SET_APPLICATION_ID', applicationId)
      await this.setApplicationData()
    }

    const programID = this.$router.currentRoute.params.id
    if (programID) {
      await store.dispatch('applicationRegistration/fetchUserAttributes', {
        user_id: this.userId,
      })

      await store.dispatch('programs/fetchProgramById', programID)
        .then(response => {
          store.commit('applicationRegistration/SET_PROGRAM', response)
          store.commit('applicationRegistration/SET_STEP_STATUS')
          this.prepareData()
        })
    }

    store.commit('SET_LOADING_STATUS', false)

    if (applicationId) {
      await store.dispatch('alertMessage/fetchInfoMessages',{ application_id: applicationId })
    }
  },
  async beforeRouteEnter(to, from, next) {
    const role = getUserData().role
    const loggedUserId = getUserData().id
    const programId = to.params.id
    const response = await axios.get(`programs/${programId}`)
    const program = response.data.data
    next((vm) => {
      if (!program.is_active) {
        if (program.sharing_settings.type === 'only_selected_accounts') {
          const isAvaliableForThisUser = program.sharing_settings.selectedAccounts.some(item => item === loggedUserId)
          if (!isAvaliableForThisUser) {
            vm.$router.replace({name: "error-404"})
            return
          }
        }
      }

      if (role == 'parent' && from.name !== "application-select-child" && to.query.app_id == undefined) {
        vm.$router.replace({name: "application-select-child", params: {id: programId}})
      }
    });
  },
  methods: {
    async prepareData() {
      this.isDataFullPrepared = false
      await this.prepareConditionsFromSteps()
      await this.setFormsData()
      await this.checkIfAllFieldsInStepAreHidden()
      await this.enableSteps()
      await this.selectActiveTab()
      await this.disableEditingStepsIfpaymentContractIsExist()
      await this.disableEditingStepsByEditingApplicationPermissions()
      this.isDataFullPrepared = true
    },
    async setFormsData() {
      store.commit('applicationRegistration/SET_FROMS_DATA')
      store.commit('applicationRegistration/SET_FORMS_VALUES_FROM_USER_ATTRIBUTES')
      store.commit('applicationRegistration/SET_FORMS_VALUES_FROM_APPLICATION_FIELDS')
      store.commit('applicationRegistration/CHECK_CONDITIONS')
    },
    async setApplicationData() {
      await store.dispatch('applications/fetchApplicationById', this.applicationId)
        .then(response => {
          if (response.sharing_settings.type === 'only_selected_accounts') {
            const loggedUserId = getUserData().id
            const isAvaliableForThisUser = response.sharing_settings.selectedAccounts
              .some(item => item === loggedUserId)
            if (!isAvaliableForThisUser) {
              this.$router.push('error-404')
              return
            }
          }
          store.commit('applicationRegistration/SET_APPLICATION', response)
          if (response.payment_contract) {
            store.commit('applicationRegistration/SET_PAYMENT', response.payment_contract)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async selectActiveTab() {
      if (this.$router.currentRoute.query.tab_index) {
        this.$nextTick(() => {
          this.tabIndex = Number(this.$router.currentRoute.query.tab_index)
        })
      } else {
        const index = this.filteredStepsList.map(step => step.status).lastIndexOf("Approved")
        this.$nextTick(() => {
          if(index == this.filteredStepsList.length - 1) {
            this.tabIndex = index
          } else {
            this.tabIndex = index + 1
          }
        })
      }
    },
    setTabIndexQuery() {
      this.$nextTick(() => {
        const query = Object.assign({}, this.$route.query)
        if (query.tab_index == this.tabIndex) return
        query.tab_index = this.tabIndex
        this.$router.push({ name: 'application-create', query })
      })
    },
    async enableSteps() {
      for (let i = 0; i < this.filteredStepsList.length; i++) {
      //   this.filteredStepsList[i].isDisabled = true
      //
      //   if (i === 0) {
      //     this.filteredStepsList[i].isDisabled = false
      //   }
      //
      //   if (["Approved"].includes(this.filteredStepsList[i].status)) {
      //     this.filteredStepsList[i].isDisabled = false
      //     // if (i < this.filteredStepsList.length - 1) {
      //     //   this.filteredStepsList[i + 1].isDisabled = false
      //     // }
      //     continue
      //   }
      //
      //   if (["Rejected"].includes(this.filteredStepsList[i].status)) {
      //     this.filteredStepsList[i].isDisabled = false
      //     continue
      //   }
      //
      //   if (i > 1 && ["Required To Continue", "Requires Approval To Continue"].includes(this.filteredStepsList[i - 1].requirement_option) &&
      //     this.filteredStepsList[i - 1].status !== "Approved"
      //   ) {
      //     // this.filteredStepsList[i].isDisabled = false
      //     // continue
      //     break
      //   } else {
      //     this.filteredStepsList[i].isDisabled = false
      //
      //     if (["Required To Continue", "Requires Approval To Continue"].includes(this.filteredStepsList[i].requirement_option)) {
      //       break
      //     }
      //   }


        if (this.filteredStepsList[i].status == "Approved") {
          this.filteredStepsList[i].isDisabled = false
          if (i < this.filteredStepsList.length - 1) {
            this.filteredStepsList[i+1].isDisabled = false
          }
        } else if (this.filteredStepsList[i].requirement_option == "Required To Continue" 
         || this.filteredStepsList[i].requirement_option == "Requires Approval To Continue") {
          this.filteredStepsList[i].isDisabled = false
          break
        } else {
          this.filteredStepsList[i].isDisabled = false
        }

        if (this.isApplicationAccepted) {
          this.filteredStepsList[i].isDisabled = false
        }
      }
    },
    goNextTabIfAvailable() {
      this.enableSteps()
      this.$nextTick(() => {
        this.$store.commit('applicationRegistration/INCREMENT_TAB_INDEX')
      })
    },
    stepIndex(val) {
      const index = val + 1
      return index < 10 ? `0${index}` : index
    },
    async prepareConditionsFromSteps() {
      store.commit('applicationRegistration/PREPARE_CONDITIONS_FROM_STEPS')
    },
    async checkIfAllFieldsInStepAreHidden() {
      store.commit('applicationRegistration/CHECK_IF_ALL_FIELDS_IN_STEP_ARE_HIDDEN')
    },
    toggleCollapseTabs() {
      this.isCollapsed = !this.isCollapsed
    },
    disableEditingStepsIfpaymentContractIsExist() {
      this.$store.commit('applicationRegistration/DISABLE_EDITING_STEPS_IF_PAYMENT_CONTRACT_IS_SELECTED')
    }    ,
    disableEditingStepsByEditingApplicationPermissions() {
      this.$store.commit('applicationRegistration/SET_EDITABLE_SETTINGS_FOR_STEPS')
    }
  }
}
</script>